import styled from 'styled-components';

import { HorizontalAlignment } from 'packages/kakapo-ui-kit/types/Layout';

export const DropdownListItem = styled.li`
	list-style: none;
	padding: 0 25px;

	img {
		vertical-align: middle;
		display: inline-block;
		margin-right: 8px;
		margin-left: -3px;
		margin-top: -2px;
		width: 20px;
	}

	a {
		color: ${(props) => props.theme.colors.slateBlue};
		display: block;
		margin-bottom: 10px;
		text-decoration: none;

		&:hover {
			color: ${(props) => props.theme.colors.antracite};
		}
	}

	:last-child a {
		margin-bottom: 0;
	}
`;

export const DropdownListSeperator = styled.div`
	width: 100%;
	height: 1px;
	padding-top: 5px;
	margin-bottom: 15px;
	border-bottom: 1px solid ${(props) => props.theme.colors.lightBlueLight};
`;

interface IProps {
	hasNegativeOffsetTop?: boolean;
	horizontalAlignment?: HorizontalAlignment;
	width?: string;
}

export default styled.ul<IProps>`
	min-width: ${(props) => props.width ?? '250px'};
	background: ${(props) => props.theme.colors.white};
	box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.3);
	border-radius: 6px;
	position: absolute;
	z-index: 10;
	${(props) => (props.horizontalAlignment === HorizontalAlignment.Left ? 'left: 0' : 'right: 0')};
	padding: 18px 0 15px 0;
	margin-top: 10px;
	transform: translateY(${(props) => (props.hasNegativeOffsetTop ? '-12px' : '0')});

	// Hidden object behind the arrow of the tooltip that adds shadow
	&:before {
		content: '';
		position: absolute;
		z-index: -1;
		top: -2px;
		${(props) =>
			props.horizontalAlignment === HorizontalAlignment.Left ? 'left: 25px' : 'right: 25px'};
		width: 2px;
		height: 2px;
		background: ${(props) => props.theme.colors.white};
		box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
		display: block;
	}

	// Arrow of the tooltip
	&:after {
		content: '';
		position: absolute;
		top: -10px;
		${(props) =>
			props.horizontalAlignment === HorizontalAlignment.Left ? 'left: 20px' : 'right: 20px'};
		z-index: 8;
		border: 5px solid transparent;
		border-color: transparent transparent ${(props) => props.theme.colors.white} transparent;
		display: block;
	}
`;
